module.exports = __webpack_public_path__ + "static/letsgets-2a37041f77f27fe7d2f687feea629fb1.png";